// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"InConstruction_headerTitle_eCoKA","titleInfo":"InConstruction_titleInfo_ywDWQ"};